// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"328":"8d5ccf","430":"65e57a","527":"d8bba2"}[chunkId] + ".css";
};